import { render } from "./DsLog.vue?vue&type=template&id=a1c6d710&scoped=true&ts=true"
import script from "./DsLog.vue?vue&type=script&lang=ts"
export * from "./DsLog.vue?vue&type=script&lang=ts"

import "./DsLog.vue?vue&type=style&index=0&id=a1c6d710&scoped=true&lang=css"
import "./DsLog.vue?vue&type=style&index=1&id=a1c6d710&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1c6d710"]])

export default __exports__